import React from 'react';
import styled, { css } from 'styled-components';
import { useTheme } from 'styled-components';

const PartnerImg = styled.img<{ position: 'right' | 'center' }>`
  position: absolute;
  top: 50%;
  max-height: 60px;
  max-width: 200px;
  object-fit: contain;
  pointer-events: none;
  z-index: 1;
  ${({ position }) =>
    position === 'center'
      ? css`left: 50%; transform: translate(-50%, -50%);`
      // inset-inline-end mirrors to the left under dir="rtl", keeping the
      // logo opposite the Back button instead of on top of it.
      : css`inset-inline-end: 20px; transform: translateY(-50%);`}
`;

const Logo: React.FC = () => {
  const { logo, logoPosition } = useTheme();
  return (
    <>
      {logo && <PartnerImg src={logo} alt="Partner logo" position={logoPosition} />}
    </>
  );
};

export default Logo;
